
<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.itemId)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseEdit from '@shared_components/base_edit.vue';

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(itemId) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ITEM_WEIGHT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: itemId
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.itemWeight;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateServerEntry: function(itemWeight) {
      this.pageLoading = true;
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(itemWeight, this.editableEntry.validations);
      // console.log(filtered, filtered);
      this.$apollo
        .mutate({
          mutation: UPDATE_ITEM_WEIGHT_MUTATION,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.createItemWeight.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_ITEM_WEIGHT_QUERY = gql `
  query($itemId: ID!){
    accountContext{
      itemWeight(itemId: $itemId) {
        itemId
        item{
          id
          name
          description
          account{
            name
          }
          brand{
            name
          }
          unit{
            name
          }
        }
        weights{
          id
          packagingId
          packaging{
            name
          }
          grossWeight
          liquidWeight
        }
        validations
      }
    } 
  }
`;

const UPDATE_ITEM_WEIGHT_MUTATION = gql `
  mutation($input: ItemWeightCreateInputObject!) {
    createItemWeight(input: $input) {
      itemWeight {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

